module.exports = __webpack_public_path__ + "img/business-4.76bf5b1c.jpg";